module.exports = __webpack_public_path__ + "img/11d.f5457fe4.svg";